import axios from "../../utils/axios";

// 订单管理
export function getList(query) {
    return axios({
        url: "orderManage/getList",
        method: "get",
        params: query
    });
}

export function expressionlist() {
    return axios({
        url: "orderManage/expressionList",
        method: "get"
    });
}

// 订单管理详情
export function getOrderInfo(query) {
    return axios({
        url: "orderManage/getInfo",
        method: "get",
        params: query
    });
}
//修改实付金额
export function savePrice(data) {
    return axios({
        url: "/orderManage/editPrice",
        method: "post",
      //  headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
//修改订单状态
export function updateState(data) {
    return axios({
        url: "/orderManage/updateState",
        method: "post",
       // headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
//修改承运公司
export function upodateexpression(data) {
    return axios({
        url: "/orderManage/upodateExpression",
        method: "post",
       // headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
//修改承运公司
export function upodateoddNumbers(data) {
    console.log("aaaaaa=",data)
    return axios({
        url: "/orderManage/upodateOddNumbers",
      //  headers:{'content-type': "application/x-www-form-urlencoded"},
        method: "post",
        data: data
    });
}
//修改运费
export function editfreight(data) {
    return axios({
        url: "/orderManage/upodateFreight",
        method: "post",
       // headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}

// 专属客服
export function getUserList() {
    return axios({
        url: "orderManage/getUserList",
        method: "get"
    });
}

// 取消订单
export function cancleOrder(query) {
    return axios({
        url: "orderManage/cancle",
        method: "get",
        params: query
    });
}

// 下一步
export function nextStept(query) {
    return axios({
        url: "orderManage/next",
        method: "get",
        params: query
    });
}

// 发货
export function send(query) {
    return axios({
        url: "orderManage/send",
        method: "get",
        params: query
    });
}
// 归还额度
export function returnLine(query) {
    return axios({
        url: "orderManage/return",
        method: "get",
        params: query
    });
}
// 物流信息
export function getfontwb(data) {
    return axios({
        url: "webcli/getfontwb",
        method: "post",
        params: data
    });
}
export function getfontdhl(data) {
    return axios({
        url: "dhl//getfontdhl",
        method: "post",
        params: data
    });
}

//发货图片修改
export function updSendPicApi(query) {
  return axios({
      url: "/orderManage/updSendPic",
      method: "post",
      params: query
  });
}

//报关单据修改
export function updSendTariffbillApi(query) {
  return axios({
      url: "/orderManage/updSendTariffbill",
      method: "post",
      params: query
  });
}

//发票图片修改
export function updSendInvoiceApi(query) {
  return axios({
      url: "/orderManage/updSendInvoice",
      method: "post",
      params: query
  });
}
